import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import {
  dateFormatter,
  dateFormatterWithTime,
} from '../../../utils/dateFormatter';
import { useDispatch, useSelector } from 'react-redux';
import { addTopicRequest, closeTopicRequest } from '../../../redux/topicRedux';
import { getUser } from '../../../redux/usersRedux';
import { useState } from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const Topics = ({
  topics,
  temat,
  naglowek,
  buttonText,
  category,
  sliderBool,
}) => {
  const [open, setOpen] = useState(false);
  const user = useSelector((state) => getUser(state));
  const dispatch = useDispatch();
  const handleAction = async (id) => {
    await dispatch(closeTopicRequest(id));
  };
  const [message, setMessage] = useState('');
  const [expiresAt, setExpiresAt] = useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = async () => {
    const newTopic = {
      message,
      expiresAt,
      userId: user.users.id,
      category,
    };
    await dispatch(addTopicRequest(newTopic));
    handleClose();
  };

  console.log(topics);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Typography variant="h6">{naglowek}</Typography>
        <Button
          sx={{ visibility: sliderBool ? 'hidden' : 'visible' }}
          onClick={handleOpen}
          variant="outlined"
        >
          {buttonText}
        </Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '15%' }}>Autor</TableCell>
            <TableCell sx={{ width: '10%' }}>Data utworzenia</TableCell>
            <TableCell sx={{ width: '55%' }}>Wiadomość</TableCell>
            <TableCell sx={{ width: '15%' }}>Data wygaśnięcia</TableCell>
            <TableCell
              sx={{
                width: '15%',
                visibility: sliderBool ? 'hidden' : 'visible',
              }}
            >
              Akcja
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {topics && topics.length > 0 ? (
            topics.map((topic) => (
              <TableRow key={topic.id}>
                <TableCell>{`${topic.user.firstName}`}</TableCell>
                <TableCell>{dateFormatter(topic.createdAt)}</TableCell>
                <TableCell>{topic.message}</TableCell>
                <TableCell>{dateFormatterWithTime(topic.expiresAt)}</TableCell>
                <TableCell
                  sx={{ visibility: sliderBool ? 'hidden' : 'visible' }}
                >
                  <Button
                    onClick={() => handleAction(topic.id)}
                    variant="contained"
                  >
                    Zamknij
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <Typography
                  sx={{ fontWeight: 'bold' }}
                  variant="body2"
                  color="black"
                >
                  {temat}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {buttonText}
          </Typography>
          <Box sx={{ mt: 2, display: 'flex' }}>
            <TextField
              id="outlined-basic"
              label="Komunikat"
              variant="outlined"
              sx={{ width: '600px' }}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                //   label={t('pz04.hourBlockTo')}
                format="DD.MM.YYYY HH mm"
                label="Data wygaśnięcia"
                views={['year', 'month', 'day', 'hours', 'minutes']}
                value={dayjs(expiresAt)}
                onChange={(newValue) => {
                  setExpiresAt(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              bgcolor: '#C09A53',
              ':hover': { bgcolor: '#9c7c43' },
            }}
            onClick={handleSubmit}
          >
            Utwórz
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};
export default Topics;
